import { render, staticRenderFns } from "./MsMessageBoxFW.vue?vue&type=template&id=45b0732a&scoped=true"
import script from "./MsMessageBoxFW.vue?vue&type=script&lang=js"
export * from "./MsMessageBoxFW.vue?vue&type=script&lang=js"
import style0 from "./MsMessageBoxFW.vue?vue&type=style&index=0&id=45b0732a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b0732a",
  null
  
)

export default component.exports